package com.elan.edubridge.ui.shell

import com.elan.edubridge.shared.di.SharedGraph
import kotlinx.browser.document
import kotlinx.coroutines.MainScope
import kotlinx.coroutines.launch
import org.w3c.dom.HTMLButtonElement

/**
 * 만 14세 미만 사용자는 법정대리인 동의가 완료되기 전까지 이용을 시작할 수 없다.
 * Android의 `GuardianConsentPendingScreen`과 같은 세션 차단 화면이다.
 */
object GuardianConsentPendingPage {
    private val scope = MainScope()
    private val accountRepository = SharedGraph.createAccountRepository()

    fun render() {
        renderPage(
            "eb-legal",
            """
                <a class="eb-legal__brand" href="/">${icon("icon-bridge-logo", "lg")}EduBridge</a>
                <article class="eb-legal__card">
                    <div class="eb-legal__header">
                        <h1>보호자 동의를 기다리고 있어요</h1>
                        <span class="eb-chip eb-chip--warning">${icon("icon-warning", "xs")}이용 대기</span>
                    </div>
                    <p class="eb-meta">보호자 동의가 완료되면 서비스를 이용할 수 있어요.</p>
                </article>
                <button type="button" id="guardian-consent-logout" class="eb-button eb-button--ghost">로그아웃</button>
            """.trimIndent(),
        )
        (document.getElementById("guardian-consent-logout") as HTMLButtonElement).onclick = {
            scope.launch { accountRepository.logout() }
            null
        }
    }
}
